"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports.PersistQueryClientProvider = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _persist = require("./persist");

var _reactjs = require("../reactjs");

var _isRestoring = require("../reactjs/isRestoring");

var PersistQueryClientProvider = function PersistQueryClientProvider(_ref) {
  var client = _ref.client,
      children = _ref.children,
      persistOptions = _ref.persistOptions,
      onSuccess = _ref.onSuccess,
      props = _objectWithoutProperties(_ref, ["client", "children", "persistOptions", "onSuccess"]);

  var _react$default$useSta = _react["default"].useState(true),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      isRestoring = _react$default$useSta2[0],
      setIsRestoring = _react$default$useSta2[1];

  var refs = _react["default"].useRef({
    persistOptions: persistOptions,
    onSuccess: onSuccess
  });

  _react["default"].useEffect(function () {
    refs.current = {
      persistOptions: persistOptions,
      onSuccess: onSuccess
    };
  });

  _react["default"].useEffect(function () {
    var isStale = false;
    setIsRestoring(true);

    var _ref2 = (0, _persist.persistQueryClient)(_objectSpread(_objectSpread({}, refs.current.persistOptions), {}, {
      queryClient: client
    })),
        _ref3 = _slicedToArray(_ref2, 2),
        unsubscribe = _ref3[0],
        promise = _ref3[1];

    promise.then(function () {
      if (!isStale) {
        refs.current.onSuccess == null ? void 0 : refs.current.onSuccess();
        setIsRestoring(false);
      }
    });
    return function () {
      isStale = true;
      unsubscribe();
    };
  }, [client]);

  return /*#__PURE__*/_react["default"].createElement(_reactjs.QueryClientProvider, (0, _extends2["default"])({
    client: client
  }, props), /*#__PURE__*/_react["default"].createElement(_isRestoring.IsRestoringProvider, {
    value: isRestoring
  }, children));
};

exports.PersistQueryClientProvider = PersistQueryClientProvider;